import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, NavItem } from "reactstrap";
import PropTypes from "prop-types";
import Logo from "./../../../assets/images/logo.png";
import useBackendAccessApi from "../../../hooks/useBackendAccessApi";
import NetworkStatus from "../../../utils/networkStatus";
import useMixpanelEventAction from "../../../config/mixpanel/useMixpanelEventAction";
import { headerData } from "../../../locales/en";
import "./headerdashboard.scss";
import "../sidebar/skeleton.css";
import { removeLoginAsNameFromLocalStorage } from "../../loginasuser/LoginAsUser";
import { useDispatch } from "react-redux";
import useProfile from "../../../hooks/useProfile";
import { userLogout } from "../../../redux/loginSlice";
import {
  ACCOUNT,
  DASHBOARD,
  FAQS,
  INVOICE,
  PARTNER_DASHBOARD,
  STATEMENTS
} from "../../../route/paths";
import { hasRole, ROLE_REFERRAL_PARTNER } from "../../../utils/accountRoles";

const HeaderDashboardWithProfile = ({ direction, ...args }) => {
  const { logoutMixpanelEvent } = useMixpanelEventAction();
  const initialRender = useRef(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { IsBackendPermission } = useBackendAccessApi();
  const [hasBackendPermission, setHasBackendPermission] = useState(false);
  const [isLogging, setIsLogging] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const dispatch = useDispatch();
  const { profile, profileName, loading: profileLoading } = useProfile();
  // Dual partner/client accounts get a quick link back to the partner portal.
  // Role names are persisted from login (reliable regardless of profile shape).
  const isAlsoPartner = hasRole(ROLE_REFERRAL_PARTNER);

  const isBackendPermissionAccess = useCallback(async () => {
    try {
      const response = await IsBackendPermission();
      setHasBackendPermission(response?.data?.data);
    } catch {
      setHasBackendPermission(false);
    }
  }, [IsBackendPermission]);

  useEffect(() => {
    setIsLogging(profile && Object.keys(profile).length !== 0);
  }, [profile]);

  useEffect(() => {
    if (initialRender.current) {
      isBackendPermissionAccess();
      initialRender.current = false;
    }
  }, [isBackendPermissionAccess]);

  const handleLogout = () => {
    removeLoginAsNameFromLocalStorage();
    logoutMixpanelEvent(); // reset mixpanel
    dispatch(userLogout());
  };

  const BarLoader = () => {
    return (
      <div className="load_bars_wrapper">
        <div className="load_bars" />
      </div>
    );
  };
  return (
    <>
      <div className="home-header">
        <div className="container">
          <div className="home-header-wrap d-flex justify-content-between align-items-center">
            <div className="logo">
              <Link to={INVOICE}>
                <img src={Logo} alt="logo" />
              </Link>
            </div>
            {isLogging && (
              <div className="profile-menu">
                <Dropdown
                  className="profile-dropdown"
                  isOpen={dropdownOpen}
                  toggle={toggle}
                  direction={direction}
                >
                  <DropdownToggle caret className="profile-name">
                    <span className="profile-name-text">
                      {profileLoading ? <BarLoader /> : profileName}
                    </span>
                  </DropdownToggle>
                  <DropdownMenu {...args}>
                    {isAlsoPartner && (
                      <NavItem>
                        <Link to={PARTNER_DASHBOARD}>Partner portal</Link>
                      </NavItem>
                    )}
                    {hasBackendPermission && (
                      <NavItem>
                        <Link to={DASHBOARD}>{headerData?.administration}</Link>
                      </NavItem>
                    )}
                    <NavItem>
                      <Link to={INVOICE}>{headerData?.myInvoices}</Link>
                    </NavItem>
                    <NavItem>
                      <Link to={ACCOUNT}>{headerData?.myAccount}</Link>
                    </NavItem>
                    <Link to={STATEMENTS}>{headerData?.statements}</Link>
                    <NavItem>
                      <Link to={FAQS}>{headerData?.faqs}</Link>
                    </NavItem>
                    <NavItem>
                      <Link to="#" onClick={handleLogout}>
                        {headerData?.logout}
                      </Link>
                    </NavItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="blank-height" />
      <NetworkStatus />
    </>
  );
};

HeaderDashboardWithProfile.propTypes = {
  direction: PropTypes.string
};
export default HeaderDashboardWithProfile;
